module.exports = __webpack_public_path__ + "img/yano_Q_400_15_3.6b84747f.png";